










































































































































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Icon from '@/components/common/elements/Icon.vue';
import CostInputDetailsSummaryPanel from '@/components/construction/constructionedit/CostInputDetailsSummaryPanel.vue';
import CreateDetailsPanelTable from '@/components/common/modules/CreateDetailsPanelTable.vue';
import DetailsSummaryArea from '@/components/common/modules/DetailsSummaryArea.vue';
import { FieldChildrenProp } from '@/services/hexabase/types';
import Input from '@/components/common/elements/Input.vue';
import Select from '@/components/common/elements/Select.vue';
import TableDataTag from '@/components/common/modules/TableDataTag.vue';

@Component({
  components: {
    CostInputDetailsSummaryPanel,
    SingleText,
    Icon,
    CreateDetailsPanelTable,
    DetailsSummaryArea,
    Input,
    Select,
    TableDataTag
  }
})
export default class ExpectedCostInput extends Vue {
  // 親コンポーネントから送られてくる表示データ
  @Prop({ default: () => [] })
  private expectedCostInputDetailFieldsDatas!: Array<Array<Array<FieldChildrenProp>>>;
  // 親コンポーネントから送られてくるカラム情報
  @Prop({ default: '' })
  private expectedCostInputDetailFieldCols?: Array<string>;
  // 親コンポーネントから送られてくる表示データ
  @Prop({ default: () => [] })
  private fixedCostInputDetailFieldsDatas!: Array<Array<Array<FieldChildrenProp>>>;
  // 親コンポーネントから送られてくるカラム情報
  @Prop({ default: '' })
  private fixedCostInputDetailFieldCols?: Array<string>;
  @Prop({ default: () => [] })
  private inVoiceDetailFieldsDatas!: Array<Array<FieldChildrenProp>>;
  // 親コンポーネントから送られてくるカラム情報
  @Prop()
  parentRegistDatas: any;
  @Prop()
  parentRegistFixDatas: any;
  // 受注予定額
  @Prop({ default: '0' })
  private orderPrice?: string;
  // 受注確定額
  @Prop({ default: '0' })
  private orderPriceFix?: string;
  /** 親コンポーネントが持っている各マスタのデータ */
  @Prop()
  private masterData?: any;
  // 編集モード判定制御値
  @Prop({ default: true })
  private isEditMode?: boolean;
  // 各集計データ格納用配列
  private summaryAreaArray: string[] = [];

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };

  // 画面開閉状態
  private switchMsButtonValue?: boolean = false;
  // 開閉状態アイコン
  private switchMsButtonIcon?: string = 'mdi-chevron-down';

  private switchMsButtonValue2?: boolean = false;
  private switchMsButtonIcon2?: string = 'mdi-chevron-down';

  private switchMsButtonValue3?: boolean = false;
  private switchMsButtonIcon3?: string = 'mdi-chevron-down';

  /**
   * パネル開閉ボタン
   * 確認用 仕様不明の為仮実装
   * @module showDetailInformation
   * @param {boolean} flag - パネル開閉状態フラグ
   * @return {void} - コンソールに出力
   */
  private showMsDetailInformation(index: number) {
    // if (this.switchMsButtonValue === true) {
    //   this.switchMsButtonValue = false;
    //   this.switchMsButtonIcon = 'mdi-chevron-down';
    // } else {
    //   this.switchMsButtonValue = true;
    //   this.switchMsButtonIcon = 'mdi-chevron-up';
    // }
    switch (index){
      case 1:
        if (this.switchMsButtonValue === true) {
          this.switchMsButtonValue = false;
          this.switchMsButtonIcon = 'mdi-chevron-down';
        } else {
          this.switchMsButtonValue = true;
          this.switchMsButtonIcon = 'mdi-chevron-up';
        }
        break;
      case 2:
        if (this.switchMsButtonValue2 === true) {
          this.switchMsButtonValue2 = false;
          this.switchMsButtonIcon2 = 'mdi-chevron-down';
        } else {
          this.switchMsButtonValue2 = true;
          this.switchMsButtonIcon2 = 'mdi-chevron-up';
        }
        break;
      case 3:
        if (this.switchMsButtonValue3 === true) {
          this.switchMsButtonValue3 = false;
          this.switchMsButtonIcon3 = 'mdi-chevron-down';
        } else {
          this.switchMsButtonValue3 = true;
          this.switchMsButtonIcon3 = 'mdi-chevron-up';
        }
        break;
    }
  }

  private summaryTotal() {
    let sum = 0;
    for (const i in this.expectedCostInputDetailFieldsDatas) {
      sum += this.sumTotal(this.expectedCostInputDetailFieldsDatas[i], Number(i));
    }
    return sum;
  }

  private summaryFixTotal() {
    let sum = 0;
    for (const i in this.fixedCostInputDetailFieldsDatas) {
      sum += this.sumTotal(this.fixedCostInputDetailFieldsDatas[i], Number(i));
    }
    return sum;
  }

  private sumTotal(data: Array<Array<FieldChildrenProp>>, index: number) {
    let sum = 0;
    for (const i in data) {
      // 特定の自動集計を行う、display_idの検索
      const quantityUnitPrice = data[i].find(function(v) {
        if (v.display_id === 'quantity;unit_price;unit') {
          return v['props']?.value;
        }
      });

      // 特定の自動集計を行う、display_idがある場合
      if (quantityUnitPrice) {
        const baseValue = quantityUnitPrice['props']?.value;
        const leftValue = isNaN(Number(baseValue.split(';')[0]))
          ? 0
          : Number(baseValue.split(';')[0]);
        const rightValue = isNaN(Number(baseValue.split(';')[1]))
          ? 0
          : Number(baseValue.split(';')[1]);
        sum += leftValue * rightValue;
      } else {
        const quantity = data[i].find(function(v) {
          if (v.display_id === 'quantity') {
            return v['props']?.value;
          }
        });
        const unit_price = data[i].find(function(v) {
          if (v.display_id === 'unit_price') {
            return v['props']?.value;
          }
        });
        if (quantity && unit_price) {
          sum += Number(quantity['props']?.value) * Number(unit_price['props']?.value);
        }
      }
    }
    return sum;
  }

  /**
   * 明細情報欄(材料費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module expectedCostInputMaterialCostAddDetailArea
   * @return {void}
   */
  @Emit('expectedCostInputMaterialCostAddDetailArea')
  private expectedCostInputMaterialCostAddDetailArea() {
    return { detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module expectedCostInputMaterialCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputMaterialCostDeleteRow')
  private expectedCostInputMaterialCostDeleteRow(index: number) {
    if (this.parentRegistDatas[0]) {
      this.registData = { ...this.parentRegistDatas[0] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module expectedCostInputMaterialCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputMaterialCostCreateDetailsData')
  private expectedCostInputMaterialCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module expectedCostInputMaterialCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputMaterialCostCatchInputDetail')
  private expectedCostInputMaterialCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 0;
    return response;
  }

  /**
   * 明細情報欄(労務費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module expectedCostInputMaterialCostAddDetailArea
   * @return {void}
   */
  @Emit('expectedCostInputLaborCostAddDetailArea')
  private expectedCostInputLaborCostAddDetailArea() {
    return { detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module expectedCostInputLaborCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputLaborCostDeleteRow')
  private expectedCostInputLaborCostDeleteRow(index: number) {
    if (this.parentRegistDatas[1]) {
      this.registData = { ...this.parentRegistDatas[1] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module expectedCostInputLaborCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputLaborCostCreateDetailsData')
  private expectedCostInputLaborCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module expectedCostInputLaborCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputLaborCostCatchInputDetail')
  private expectedCostInputLaborCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 1;
    return response;
  }

  /**
   * 明細情報欄(消耗品・その他経費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module expectedCostInputConsumableCostAddDetailArea
   * @return {void}
   */
  @Emit('expectedCostInputConsumableCostAddDetailArea')
  private expectedCostInputConsumableCostAddDetailArea(index: number) {
    return { detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module expectedCostInputConsumableCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputConsumableCostDeleteRow')
  private expectedCostInputConsumableCostDeleteRow(index: number) {
    if (this.parentRegistDatas[2]) {
      this.registData = { ...this.parentRegistDatas[2] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module expectedCostInputConsumableCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputConsumableCostCreateDetailsData')
  private expectedCostInputConsumableCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module expectedCostInputConsumableCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('expectedCostInputConsumableCostCatchInputDetail')
  private expectedCostInputConsumableCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 2;
    return response;
  }

  /**
   * 明細情報欄(材料費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module fixedCostInputMaterialCostAddDetailArea
   * @return {void}
   */
  @Emit('fixedCostInputMaterialCostAddDetailArea')
  private fixedCostInputMaterialCostAddDetailArea() {
    return { detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module fixedCostInputMaterialCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputMaterialCostDeleteRow')
  private fixedCostInputMaterialCostDeleteRow(index: number) {
    if (this.parentRegistDatas[0]) {
      this.registData = { ...this.parentRegistDatas[0] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module fixedCostInputMaterialCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputMaterialCostCreateDetailsData')
  private fixedCostInputMaterialCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module fixedCostInputMaterialCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputMaterialCostCatchInputDetail')
  private fixedCostInputMaterialCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 0;
    return response;
  }

  /**
   * 明細情報欄(労務費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module fixedCostInputMaterialCostAddDetailArea
   * @return {void}
   */
  @Emit('fixedCostInputLaborCostAddDetailArea')
  private fixedCostInputLaborCostAddDetailArea() {
    return { detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module fixedCostInputLaborCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputLaborCostDeleteRow')
  private fixedCostInputLaborCostDeleteRow(index: number) {
    if (this.parentRegistDatas[1]) {
      this.registData = { ...this.parentRegistDatas[1] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module fixedCostInputLaborCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputLaborCostCreateDetailsData')
  private fixedCostInputLaborCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module fixedCostInputLaborCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputLaborCostCatchInputDetail')
  private fixedCostInputLaborCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 1;
    return response;
  }

  /**
   * 明細情報欄(消耗品・その他経費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module fixedCostInputConsumableCostAddDetailArea
   * @return {void}
   */
  @Emit('fixedCostInputConsumableCostAddDetailArea')
  private fixedCostInputConsumableCostAddDetailArea(index: number) {
    return { detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module fixedCostInputConsumableCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputConsumableCostDeleteRow')
  private fixedCostInputConsumableCostDeleteRow(index: number) {
    if (this.parentRegistDatas[2]) {
      this.registData = { ...this.parentRegistDatas[2] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module fixedCostInputConsumableCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputConsumableCostCreateDetailsData')
  private fixedCostInputConsumableCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module fixedCostInputConsumableCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputConsumableCostCatchInputDetail')
  private fixedCostInputConsumableCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 2;
    return response;
  }

  /**
   * 子コンポーネントからの値を受け取り、各集計データ格納用配列の更新確認を行い、
   * 指定された各集計データ格納用配列内に値がなければ、値を格納する。、
   * @module detailsSummaryAreaOperation
   * @param {[k: string]: string} data - ラベル名、値、集計コンポーネントのインデックス
   * @return {void}
   */
  createDetailsSummaryOperation(data: { [k: string]: string }) {
    const index = Number(data.index);
    // 該当配列の値が更新されているかを確認
    if (data.value !== this.summaryAreaArray[index]) {
      this.summaryAreaArray.splice(index, 0, data.value);
    }
  }
}
